import { render, staticRenderFns } from "./PopularPages.vue?vue&type=template&id=d3d2ee42&scoped=true&"
import script from "./PopularPages.vue?vue&type=script&lang=js&"
export * from "./PopularPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d2ee42",
  null
  
)

export default component.exports